import React from 'react';

interface VersusCardProps {
  topic: string;
  thisView: { persona: string; text: string };
  otherView: { persona: string; text: string };
  personaColor: string;
}

const VersusCard: React.FC<VersusCardProps> = ({ topic, thisView, otherView, personaColor }) => {
  return (
    <div
      className="my-6 bg-white rounded-xl border border-[#e2e8f0] overflow-hidden"
      style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}
    >
      {/* Header */}
      <div className="bg-[#f8fafc] px-4 py-3 border-b border-[#e2e8f0] flex items-center gap-2">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#94a3b8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="17 1 21 5 17 9" />
          <path d="M3 11V9a4 4 0 0 1 4-4h14" />
          <polyline points="7 23 3 19 7 15" />
          <path d="M21 13v2a4 4 0 0 1-4 4H3" />
        </svg>
        <span
          className="text-[11px] font-bold text-[#94a3b8] tracking-wider"
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}
        >
          CONTESTED CLAIM · {topic}
        </span>
      </div>

      {/* Two-column body */}
      <div className="flex divide-x divide-[#e2e8f0]">
        {/* This perspective */}
        <div className="flex-1 p-4">
          <p
            className="text-[11px] font-bold mb-2 tracking-wider"
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              textTransform: 'uppercase',
              color: personaColor
            }}
          >
            {thisView.persona}
          </p>
          <p
            className="text-[13px] text-[#334155] leading-relaxed"
            style={{ fontFamily: "'Source Serif 4', Georgia, serif", lineHeight: '1.6' }}
          >
            {thisView.text}
          </p>
        </div>
        {/* Other perspective */}
        <div className="flex-1 p-4 bg-[#fafafa]">
          <p
            className="text-[11px] font-bold text-[#94a3b8] mb-2 tracking-wider"
            style={{ fontFamily: "'JetBrains Mono', monospace", textTransform: 'uppercase' }}
          >
            {otherView.persona}
          </p>
          <p
            className="text-[13px] text-[#64748b] leading-relaxed"
            style={{ fontFamily: "'Source Serif 4', Georgia, serif", lineHeight: '1.6' }}
          >
            {otherView.text}
          </p>
        </div>
      </div>

      {/* Footer */}
      {/* <div className="bg-[#f8fafc] border-t border-[#e2e8f0] px-4 py-2.5 text-center">
        <span
          className="text-[12px] font-semibold text-[#059669] cursor-pointer hover:text-[#047857] transition-colors"
          style={{ fontFamily: "'JetBrains Mono', monospace" }}
        >
          See both full arguments →
        </span>
      </div> */}
    </div>
  );
};

export default VersusCard;
